export default function (message) {
  if (/user.*not.*exist/i.test(message)) return 'Usuário não existe.';
  if (/incorrect.*username.*password/i.test(message)) return 'Email ou senha incorretos.';
  if (/user.*already.*exist/i.test(message)) return 'Email já cadastrado.';
  if (/validation.*password/i.test(message)) return 'Formato de senha inválido.';
  if (message === "Invalid verification code provided, please try again.") return 'Código inválido, tente novamente.';
  if (message === "Username/client id combination not found.") return "Usuário não existe.";
  if (message === "Attempt limit exceeded, please try after some time.") return "Número máximo de tentativas excedido, tente novamente mais tarde.";
  return message;
}
